"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_use_1 = require("react-use");
var typography_1 = require("../../../typography");
var styles_1 = require("./styles");
function Options(_a) {
    var options = _a.options, _b = _a.value, value = _b === void 0 ? [] : _b, onChange = _a.onChange;
    var optionsRef = react_1.default.useRef(null);
    var handleChange = function (clickedValue) {
        onChange(value.includes(clickedValue)
            ? value.filter(function (v) { return v !== clickedValue; })
            : __spreadArray(__spreadArray([], __read(value)), [clickedValue]));
    };
    react_1.default.useEffect(function () {
        var _a;
        (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('button')[0].focus();
    }, []);
    react_use_1.useKey(function (e) { return ['ArrowUp', 'ArrowDown'].includes(e.key); }, function (e) {
        e.preventDefault();
        var direction = e.key === 'ArrowUp' ? 'UP' : 'DOWN';
        if (optionsRef.current) {
            var items = __spreadArray([], __read(optionsRef.current.querySelectorAll('button')));
            var currentItemIndex = items.findIndex(function (item) { return item === document.activeElement; });
            var nextIndex = 0;
            if (direction === 'DOWN') {
                nextIndex = currentItemIndex + 1 >= items.length ? 0 : currentItemIndex + 1;
            }
            else {
                nextIndex = currentItemIndex - 1 < 0 ? items.length - 1 : currentItemIndex - 1;
            }
            items[nextIndex].focus();
        }
    }, undefined, [optionsRef.current]);
    return (react_1.default.createElement(styles_1.ItemsWrapper, { ref: optionsRef }, options.map(function (option, i) { return (react_1.default.createElement(styles_1.Item, { key: i, color: value.includes(option.value) ? 'PALE_BLUE_50' : 'WHITE', hoverColor: value.includes(option.value) ? 'PALE_BLUE_40' : 'PALE_BLUE_40', onClick: function () { return handleChange(option.value); }, tabIndex: -1, role: "option", "aria-selected": value.includes(option.value) ? 'true' : 'false' },
        react_1.default.createElement(typography_1.Body, { color: value.includes(option.value) ? 'BLUE_50' : 'GREY_90', level: "3" }, option.display))); })));
}
exports.default = Options;
